/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
  return {
    mode: theme?.customization?.navType,
    common: {
      black: theme.colors?.darkPaper,
    },
    primary: {
      light: theme.colors?.primaryLight,
      main: theme.colors?.primaryMain,
      dark: theme.colors?.primaryDark,
      200: theme.colors?.primary200,
      800: theme.colors?.primary800,
      900: theme.colors?.primary900,
    },
    secondary: {
      light: theme.colors?.secondaryLight,
      main: theme.colors?.secondaryMain,
      dark: theme.colors?.secondaryDark,
      200: theme.colors?.secondary200,
      800: theme.colors?.secondary800,
    },
    success: {
      light: theme.colors?.successLight,
      main: theme.colors?.successMain,
      dark: theme.colors?.successDark,
      200: theme.colors?.success200,
      800: theme.colors?.success800,
    },
    warning: {
      light: theme.colors?.warningLight,
      main: theme.colors?.warningMain,
      semiDark: theme.colors?.warningSemiDark,
      dark: theme.colors?.warningDark,
      800: theme.colors?.warning800,
    },
    error: {
      light: theme.colors?.errorLight,
      main: theme.colors?.errorMain,
      dark: theme.colors?.errorDark,
      700: "#d32f2f",
      800: theme.colors?.error800,
    },
    grey: {
      50: theme.colors?.grey50,
      100: theme.colors?.grey100,
      500: theme.darkTextSecondary,
      600: theme.heading,
      700: theme.darkTextPrimary,
      light: theme.colors?.grey100,
      main: theme.colors?.grey700,
      dark: theme.colors?.grey800,
      900: theme.textDark,
    },
    orange: {
      light: theme.colors?.orangeLight,
      main: theme.colors?.orangeMain,
      dark: theme.colors?.orangeDark,
    },
    pink: {
      light: theme.colors?.pinkLight,
      main: theme.colors?.pinkMain,
      dark: theme.colors?.pinkDark,
    },
    teal: {
      light: theme.colors?.tealLight,
      main: theme.colors?.tealMain,
      dark: theme.colors?.tealDark,
    },
    lime: {
      light: theme.colors?.limeLight,
      main: theme.colors?.limeMain,
      dark: theme.colors?.limeDark,
    },
    dark: {
      light: theme.colors?.darkTextPrimary,
      main: theme.colors?.darkLevel1,
      dark: theme.colors?.darkLevel2,
      800: theme.colors?.darkBackground,
      900: theme.colors?.darkPaper,
    },
    text: {
      primary: theme.darkTextPrimary,
      secondary: theme.darkTextSecondary,
      dark: theme.textDark,
      hint: theme.colors?.grey100,
    },
    background: {
      paper: theme.paper,
      default: theme.backgroundDefault,
    },
  };
}
